import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import useFlavorFormData from "../../../../hooks/useFlavorFormData";
import FlavorGeneralInfoSection from "./FlavorGeneralInfoSection";
import FlavorTagsSection from "./FlavorTagsSection";
import FlavorSEOSection from "./FlavorSEOSection";
import FlavorImageUploadSection from "./FlavorImageUploadSection";
import FlavorIngredientsSection from "./FlavorIngredientsSection";
import FlavorVisibilitySelector from "./FlavorVisibilitySelector";

const FlavorFormModal = ({ onClose, onSave, flavor }) => {
  const {
    formData,
    setFormData,
    primaryPreview,
    secondaryPreviews,
    handlePrimaryImageChange,
    handleSecondaryImagesChange,
    handleSubmit,
    uploading,
    icings,
    ingredientOptions,
    loadingIngredients,
    dietaryTagsOptions,
    allergenOptions,
  } = useFlavorFormData(flavor, onClose, onSave);

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{flavor ? "Edit Flavor" : "Add New Flavor"}</DialogTitle>
      <DialogContent>
        <FlavorGeneralInfoSection
          formData={formData}
          setFormData={setFormData}
          icings={icings}
        />

        <FlavorIngredientsSection
          ingredientsOptions={ingredientOptions}
          loadingIngredients={loadingIngredients}
          formData={formData}
          setFormData={setFormData}
        />

        <FlavorTagsSection
          formData={formData}
          setFormData={setFormData}
          dietaryTags={dietaryTagsOptions}
          allergens={allergenOptions}
        />

        <FlavorSEOSection formData={formData} setFormData={setFormData} />

        <FlavorVisibilitySelector
          formData={formData}
          setFormData={setFormData}
        />

        <FlavorImageUploadSection
          formData={formData}
          primaryPreview={primaryPreview}
          secondaryPreviews={secondaryPreviews}
          handlePrimaryImageChange={handlePrimaryImageChange}
          handleSecondaryImagesChange={handleSecondaryImagesChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={uploading}>
          {uploading ? "Uploading..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlavorFormModal;
